// @charset "utf-8";
import axios from 'axios'
// import qs from 'qs'

// 拦截器 请求
axios.interceptors.request.use(function (config) {
    // 用于服务端判断是否是ajax
    config.headers['X-Requested-With'] = 'XMLHttpRequest'
    return config
}, function (err) {
    return Promise.reject(err)
})

// 拦截器 响应
axios.interceptors.response.use(function (res) {
    // 维护中
    if (res.data.errorcode === 5001 && res.data.errormsg === 'maintenence') {
        window.location.href = '/maintenance.html'
        throw new Error('平台维护中')
    }
    // 没权限
    if (res.data.errorcode === -401 && res.data.errormsg === 'noauth') {
        // ThsLogin.showLoginBox(window.location.origin + '/reload.html')
        window.LoginInstance.show()
        throw new Error('用户未登录')
    }
    return res
}, function (err) {
    return Promise.reject(err)
})



// WEBPACK FOOTER //
// ./src/lib/axiosConfig.js